<script>
  import {
    pairs,
    pairListSelectedCategories,
    pairsLoadDone,
    pairCount,
    pairListCurrentOffset,
    pairListIsEndReached,
    pairListSelectedOrder, currentChainId,
  } from "../stores/store"
  import { quintOut } from "svelte/easing"
  import { crossfade } from "svelte/transition"
  import { flip } from "svelte/animate"
  import { Button } from "sveltestrap"
  import _ from "lodash"
  import { CATEGORIES, ORDER_BY } from "../stores/constants"
  import { getCount, getPairList, getPairs, getPairCount } from "../stores/query"

  export let inlineButton;
  export let selectCategory;
  export let removeCategory;

  export let selectedCategories;

  const [send, receive] = crossfade({
    duration: (d) => Math.sqrt(d * 200),

    fallback(node, params) {
      const style = getComputedStyle(node)
      const transform = style.transform === "none" ? "" : style.transform

      return {
        duration: 600,
        easing: quintOut,
        css: (t) => `
					transform: ${transform} scale(${t});
					opacity: ${t}
				`,
      }
    },
  })

</script>

<div>
  {#each selectedCategories as category (category)}
    <span
      in:receive={{ key: category }}
      out:send={{ key: category }}
      animate:flip={{ duration: 200 }}
    >
      <Button class="category-selected" on:click={() => removeCategory(category)}>
        {category}
      </Button>
    </span>
  {/each}
</div>
{#if inlineButton}
  <div>
    {#each _.difference(CATEGORIES, selectedCategories) as category (category)}
      <span
        in:receive={{ key: category }}
        out:send={{ key: category }}
        animate:flip={{ duration: 200 }}
      >
        <Button class="category" on:click={() => selectCategory(category)}>
          {category}
        </Button>
      </span>
    {/each}
  </div>
{:else}
  <div>
    {#each _.difference(CATEGORIES, selectedCategories) as category (category)}
      <div
        in:receive={{ key: category }}
        out:send={{ key: category }}
        animate:flip={{ duration: 200 }}
      >
        <Button class="category" on:click={() => selectCategory(category)}>
          {category}
        </Button>
      </div>
    {/each}
  </div>
{/if}
